import { Mobile } from '../core'

const $window = $(window)
const TRANSLATE_SPEED = 0.2

let shapes

$.fn.Shape = function() {
  let self = this
  self.mobileChecker = new Mobile()
  self.useCanvas = $(self).hasClass('image-shape')

  /* Elements */
  const $element = $(self).find('img')
  const $shape = $(self)
  const $canvas = $('<canvas height="0" width="0">')

  /* Status */
  let speed = undefined
  let repaint = true
  let buffer = false

  /* Reset transform */
  self.reset = function() {
    $element.css({
      transform: '',
    })
  }

  /* Parallax action */
  self.parallax = function() {
    /* Transform object */
    const objectCenter = $shape.offset().top + ($shape.height() / 2) - ($(window).height() / 2)
    let translate = (objectCenter - $window.scrollTop()) * speed

    if ($shape.hasClass('image-shape')) {
      if ($canvas.get(0).height > 0) {
        $element.css({
          visibility: 'hidden',
        })
        $canvas.css({
          transform: `translateY(${-translate}px)`,
        })
        if (!$shape.hasClass('floating')) {
          $shape.addClass('floating')
        }
      }
    } else {
      $element.css({
        transform: `translateY(${-translate}px)`,
      })
    }

    /* Keep paint status */
    repaint = true
    if (buffer) {
      buffer = false
      self.parallax()
    }
  }

  /* Scroll handler */
  self.scrolled = function() {
    if (self.mobileChecker.isMobile) {
      self.reset()
    } else if (repaint) {
      repaint = false
      window.requestAnimationFrame(self.parallax)
    } else {
      buffer = true
    }
  }

  self.canvas = function($image, $mask) {
    $shape.append($canvas)
    $shape.append($mask)
    let ctx = $canvas.get(0).getContext('2d')
    let shapeWidth = $mask.width()
    let shapeHeight = $mask.height()
    let shapeRatio = shapeWidth / shapeHeight
    let imageRatio = $image.get(0).naturalWidth / $image.get(0).naturalHeight
    if (window.devicePixelRatio > 1) {
      ctx.canvas.width = shapeWidth * window.devicePixelRatio
      ctx.canvas.height = shapeHeight * window.devicePixelRatio
      ctx.scale(window.devicePixelRatio, window.devicePixelRatio)
    } else {
      ctx.canvas.width = shapeWidth
      ctx.canvas.height = shapeHeight
    }
    $mask.remove()
    ctx.drawImage($mask.get(0), 0, 0, shapeWidth, shapeHeight)
    ctx.globalCompositeOperation = 'source-in'
    if (imageRatio >= shapeRatio) {
      ctx.drawImage($image.get(0), -((shapeHeight * imageRatio) - shapeWidth) / 2, 0, shapeHeight * imageRatio, shapeHeight)
    } else {
      ctx.drawImage($image.get(0), 0, -((shapeWidth / imageRatio) - shapeHeight) / 2, shapeWidth, shapeWidth / imageRatio)
    }
    self.parallax()
  }

  self.displayCanvas = function() {
    if (self.mobileChecker.isMobile) {
      $element.css('visibility', '')
    } else {
      let $image = $('<img>')
      let $mask = $('<img>')
      let imageLoaded = false, maskLoaded = false

      $image.on("load", function() {
        imageLoaded = true
        if (maskLoaded) {
          self.canvas($image, $mask)
        }
      })

      $mask.on("load", function() {
        maskLoaded = true
        if (imageLoaded) {
          self.canvas($image, $mask)
        }
      })

      $mask.attr("src", $shape.attr("data-shape"))
      if ("currentSrc" in $element.get(0)) {
        if ($element.get(0).currentSrc) {
          $image.attr("src", $element.get(0).currentSrc)
        } else {
          let interval = setInterval(function() {
            if ($element.get(0).currentSrc) {
              $image.attr("src", $element.get(0).currentSrc)
              clearInterval(interval)
            }
          }, 60)
        }
      } else {
        $image.attr("src", $element.attr("src"))
      }
    }
  }

  /* Display shape */
  self.displayShape = function() {
    setTimeout(function() {
      $shape.addClass('floating')
    }, 250 + 800 * speed)
  }

  /* Kill */
  self.kill = function() {
    self.mobileChecker.kill()
    $window.off('scroll resize orientationchange load', self.scrolled)
  }

  /* Initialize */
  return function() {
    /* Determine speed */
    speed = parseFloat($shape.data('speed'))
    if (isNaN(speed) || typeof speed == "undefined" || speed == null) {
      speed = TRANSLATE_SPEED
    }
    speed *= -1

    /* Add event listeners */
    $window.on('scroll resize orientationchange load', self.scrolled)
    self.scrolled()
    if (!self.mobileChecker.isMobile) {
      self.parallax()
    }

    /* Display shape */
    if (self.useCanvas) {
      self.mobileChecker.addCallbacks(
        self.displayCanvas,
        function() {
          setTimeout(self.displayCanvas, 100)
        }
      )
    } else {
      self.displayShape()
    }

    return self
  }()
}

export default {
  elements: [],

  init() {
    shapes = this
    shapes.createElements()
  },

  createElements() {
    /* Create shapes */
    $('.shape').each(function () {
      $(this).Shape()
    })
  },

  kill() {
    /* Kill shapes */
    shapes.elements.forEach(function(shape) {
      shape.kill()
    })
    shapes.elements = []
  },
}
